import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { ModelTransformer } from '../common/common.model';
import { mapCreate, mapRetrieve } from '../common/rest.operators';

import { Data, DataModelTransformer } from './form.model';

@Injectable()
export class DataFormService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    createData<T, U = T>(
        data: Data<T>,
        transformer?: ModelTransformer<T, U>,
    ): Observable<string> {
        const body = new DataModelTransformer(transformer).reverseTransform(
            data,
        );

        return this._http
            .post(`${this._appConfig.API_ENDPOINTS.FORM}/data`, body, {
                observe: 'response',
            })
            .pipe(
                mapCreate(),
                catchError(() => of(null)),
            );
    }

    retrievePayload<T, U = T>(
        dataId: number,
        transformer?: ModelTransformer<T, U>,
    ): Observable<T> {
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.FORM}/data/${dataId}`)
            .pipe(
                mapRetrieve(transformer),
                catchError(() => of(null)),
            );
    }
}
